/**
 * Copy for the homepage "TS Coach" section, read off the Figma frames
 * (desktop 3165:31031, mobile 3205:60505, states 3083:28401).
 *
 * Only the first Ask answer exists in Figma; the other three answers are
 * placeholder copy until the real ones are written.
 */

export type CoachMoment = "ask" | "morning" | "live" | "review";

export const COACH_HEADER = {
  chip: "TS Coach · Beta",
  title: ["A full trading day.", "Coached from open to close."],
  text: "Three moments, three screens in the product. TS Coach is there before you sit down, while you trade and after you log off.",
};

export type CoachCardCopy = {
  moment: CoachMoment;
  label: string;
  title: string;
  description: string;
  cta: string;
};

export const COACH_CARDS: CoachCardCopy[] = [
  {
    moment: "ask",
    label: "Ask TS Coach",
    title: "Ask anything. It knows your trades.",
    description:
      "No spreadsheets, no copy-pasting, no explaining your week again. TS Coach answers from the trades you synced, the notes you wrote and the strategies you defined.",
    cta: "Ask TS Coach",
  },
  {
    moment: "morning",
    label: "01 · Before the open · Morning Brief",
    title: "Know your state before the first trade.",
    description:
      "Answer a few questions: how you slept, how you feel, your risk limits for today. TS Coach turns it into a daily score and tells you what to pay attention to.",
    cta: "Start now",
  },
  {
    moment: "live",
    label: "02 · During the session · Live session",
    title: "It watches the rules you set for yourself.",
    description:
      "Start your session and TS Coach keeps the count: duration, rules followed, P&L. Break a rule or reach your max drawdown limit and you know right away.",
    cta: "Start now",
  },
  {
    moment: "review",
    label: "03 · After the close · Wrapped & review",
    title: "Every session wrapped. Every week reviewed.",
    description:
      "Close the session and relive the moments that shaped it. Each week, the review shows what went well, what needs work and where to focus next.",
    cta: "Start now",
  },
];

export type AskExample = { question: string; answer: string };

export const ASK_EXAMPLES: AskExample[] = [
  {
    question: "How was my performance this week?",
    answer:
      "Strong discipline week. 22 trades at a 64% win rate. Your best day was +$842, your worst −$253.",
  },
  {
    question: "Which strategy makes me the most money?",
    answer:
      "Breakouts. 68% win rate and +$1,240 net this month. Your pullback setup is close behind, but it only works before 11:00.",
  },
  {
    question: "When do I trade my best?",
    answer:
      "Tuesday and Wednesday mornings. Between 9:30 and 11:00 you win 71% of your trades. After 14:30 every trade this week was a loss.",
  },
  {
    question: "Am I managing my risk well?",
    answer:
      "Mostly. You held under your daily loss limit 6 of 7 days. The exception was Thursday: 4 news trades, −$180, three of them revenge entries.",
  },
];

export const ASK_UI = {
  repliesLabel: "Ask another",
  placeholder: "Ask ts coach about trading",
  disclaimer:
    "TS Coach can make mistakes. Always verify important information before acting on it.",
};

export const CHAT_UI = {
  name: "TS Coach",
  beta: "Beta",
  powered: "Powered by your trading data.",
  you: "You",
  coach: "TS Coach",
};

export const CHAT_MORNING = {
  title: "Your morning brief is ready!",
  cardLabel: "Here is your daily score",
  score: 67,
  scoreLabel: "Good",
  parts: [
    { label: "Body", value: 45 },
    { label: "Mind", value: 78 },
    { label: "Moment", value: 54 },
    { label: "Preparation", value: 33 },
  ],
};

export const CHAT_LIVE = {
  title: "you have reached a max drawdown limit",
  alert: "There was a breach in the rules",
  time: "1h ago",
  actions: ["Change drawdown", "Keep this way"],
};

export const CHAT_REVIEW = {
  title: "Weekly review",
  cardLabel: "Strong discipline week",
  parts: [
    { label: "Trades", value: "22" },
    { label: "Win rate", value: "64%" },
    { label: "Best day", value: "+$842" },
    { label: "Worst day", value: "−$253" },
  ],
  footer: "Held under daily loss limit 6 of 7 days",
};
